import { StatsAdapterInterface } from '../../../stats/adapter.interface';
import { StatsContextInterface } from '../../../stats/context.interface';
import { GtmStatsDataEventErrorPageInterface } from '../data/event-error-page.interface';

export class GtmStatsAdapterEventErrorPage implements StatsAdapterInterface {
  /**
   *
   * @param context
   */
  constructor(protected context: StatsContextInterface) {}

  /**
   * @inheritDoc
   */
  public getData(): GtmStatsDataEventErrorPageInterface {
    if (!this.context.local.http_status_code) {
      throw new Error('Stats local context "http_status_code" is not set.');
    }

    return {
      event: 'Error Pages',
      eventAction: this.context.local.http_status_code,
      eventLabel: this.context.global.url,
    };
  }
}
